import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
import { useTranslate } from '../../lib/i18n.js';
/**
 * Change list (molecule). What a recorded change did, field by field:
 * "Plan · Free → Premium".
 *
 * An audit entry stores a before and an after, and reading the difference
 * between two blocks of JSON is work an administrator should not have to do
 * by eye. This lays out only what changed, one field per line, each value
 * already in words.
 *
 * The arrow is decoration. A screen reader hears "Plan, from Free to
 * Premium", with the two words from the dictionary, because "Free arrow
 * Premium" is not a sentence.
 */
export function ChangeList({ items, className }) {
    const t = useTranslate();
    if (items.length === 0)
        return null;
    return (_jsx("dl", { className: cn('grid grid-cols-1 gap-x-4 gap-y-1 text-body-sm sm:grid-cols-[minmax(8rem,max-content)_minmax(0,1fr)]', className), children: items.map((item) => {
            const both = item.before !== undefined && item.after !== undefined;
            return (_jsxs("div", { className: "contents", children: [_jsx("dt", { className: "font-semibold text-text-secondary", children: item.label }), _jsx("dd", { className: "mb-1 flex min-w-0 flex-wrap items-baseline gap-x-2 break-words text-text sm:mb-0", children: both ? (
                        // The spaces between the parts are for the words a screen
                        // reader joins together; the flex gap is what spaces them on
                        // screen.
                        _jsxs(_Fragment, { children: [_jsx("span", { className: "sr-only", children: t('ui.changeList.from') }), ' ', _jsx("span", { className: "text-text-secondary", children: item.before }), ' ', _jsx("span", { "aria-hidden": "true", className: "text-text-muted", children: "\u2192" }), ' ', _jsx("span", { className: "sr-only", children: t('ui.changeList.to') }), ' ', _jsx("span", { className: "font-medium", children: item.after })] })) : (
                        // One side only — a record created, or a value recorded for
                        // context — is a value, not a change, so it reads as one.
                        _jsx("span", { className: "font-medium", children: item.after ?? item.before })) })] }, item.id));
        }) }));
}
//# sourceMappingURL=ChangeList.js.map